import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { PeriodicReportResponse } from '../../../../shared/services/integrations/PeriodicReportService';

interface ReportLinkProps {
  currentReport: PeriodicReportResponse | null;
  isSavingUrl: boolean;
  onOpenCreateReportLink: () => void;
  onSaveFinalReportUrl: (url: string) => void;
}

const ReportLink: React.FC<ReportLinkProps> = ({
  currentReport,
  isSavingUrl,
  onOpenCreateReportLink,
  onSaveFinalReportUrl
}) => {
  const { t } = useTranslation();
  
  // Simple local state - get initial value from currentReport
  const [localUrl, setLocalUrl] = useState(() => 
    currentReport?.config?.parameters?.finalReportUrl || ''
  );
  
  // Update local state when currentReport changes
  useEffect(() => {
    setLocalUrl(currentReport?.config?.parameters?.finalReportUrl || '');
  }, [currentReport]);

  return (
    <div className="report-link-modal">
      <div className="report-link-modal__content">
        <div className="section">
          <h3>{t('report')}: {currentReport?.config?.parameters?.reportName || t('unknown')}</h3>
          <p>{t('followStepsInOrder')}:</p>
        </div>

        <div className="section section--primary">
          <h4>{t('step1')}: {t('createReportInLookerStudio')} ({t('required')})</h4>
          <p><strong>{t('thisIsRequiredStep')}</strong> {t('youMustCreateReportInLookerStudio')}:</p>
          <Button 
            label={t('createReportInLookerStudio')}
            icon="pi pi-external-link"
            onClick={onOpenCreateReportLink}
            className="btn btn--sm"
          />
          <small>{t('youWillBeRedirectedToLookerStudio')}</small>
        </div>

        <div className="section section--info">
          <h4>{t('step2')}: {t('linkUpdate')} ({t('automatic')} - {t('recommended')})</h4>
          <p><strong>{t('systemWillAutomaticallySearchAndUpdate')}</strong></p>
          <small>{t('simplyCloseThisWindowAndCheckAgain')}</small>
        </div>

        <div className="section">
          <h4>{t('step2')}: {t('linkUpdate')} ({t('manual')} - {t('alternative')})</h4>
          <p>{t('ifYouWantToSpeedUpProcess')}:</p>
          <div className="url-input-section">
            <InputText
              value={localUrl}
              onChange={(e) => setLocalUrl(e.target.value)}
              placeholder="https://lookerstudio.google.com/reporting/..."
              className="w-full"
            />
            <Button 
              label={t('saveUrl')}
              onClick={() => onSaveFinalReportUrl(localUrl)}
              disabled={!localUrl || isSavingUrl}
              loading={isSavingUrl}
              className="p-button-success"
            />
          </div>
          <small>{t('copyUrlFromBrowserAfterOpeningReport')}</small>
        </div>
      </div>
    </div>
  );
};

export default ReportLink;
